import { IServicePickerWidgetServicesResponse } from '../../../ServicePickerWidget';

import { MicrofrontEventSender } from './microfrontEventSender';
import { CHANGE_SERVICES_EVENT_NAME } from './constants';

export const sendChangeServicesEvent = (terms: IServicePickerWidgetServicesResponse) => {
  const event = new MicrofrontEventSender(CHANGE_SERVICES_EVENT_NAME, terms);

  event.dispatch();
};
